export default __webpack_public_path__ + "static/icon-31-3-88be9eaa7510c2776a1d1368446cf676.png";